"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTopicBroadcastRequestDto = instanceOfTopicBroadcastRequestDto;
exports.TopicBroadcastRequestDtoFromJSON = TopicBroadcastRequestDtoFromJSON;
exports.TopicBroadcastRequestDtoFromJSONTyped = TopicBroadcastRequestDtoFromJSONTyped;
exports.TopicBroadcastRequestDtoToJSON = TopicBroadcastRequestDtoToJSON;
exports.TopicBroadcastRequestDtoToJSONTyped = TopicBroadcastRequestDtoToJSONTyped;
/**
 * Check if a given object implements the TopicBroadcastRequestDto interface.
 */
function instanceOfTopicBroadcastRequestDto(value) {
    if (!('topic' in value) || value['topic'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    return true;
}
function TopicBroadcastRequestDtoFromJSON(json) {
    return TopicBroadcastRequestDtoFromJSONTyped(json, false);
}
function TopicBroadcastRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'topic': json['topic'],
        'title': json['title'],
        'body': json['body'],
        'data': json['data'] == null ? undefined : json['data'],
        'campaignId': json['campaignId'] == null ? undefined : json['campaignId'],
    };
}
function TopicBroadcastRequestDtoToJSON(json) {
    return TopicBroadcastRequestDtoToJSONTyped(json, false);
}
function TopicBroadcastRequestDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'topic': value['topic'],
        'title': value['title'],
        'body': value['body'],
        'data': value['data'],
        'campaignId': value['campaignId'],
    };
}
